import { ExtensionBadgeIcons } from "@afriannotate/app/components/ExtensionBadges/ExtensionBadges";
import "./Sensitivity.prefix.css";

/** Project header: the level the project is handled at, when it is not
 *  normal, and whether its data is on hold. */
export const SensitivityChip = ({ project }) => {
  const found = project?.extensions?.sensitivity;
  if (!found || (found.level === "normal" && !found.hold)) return null;
  // Icons, not words: a project header is crowded, and what each one
  // means is in its tooltip.
  const badges = [];
  if (found.level !== "normal") {
    badges.push({
      label: found.label,
      title: `${found.label}: how carefully this project's data must be handled`,
      tone: found.level === "restricted" ? "negative" : "warning",
      icon: found.level === "restricted" ? "block" : "lock",
    });
  }
  if (found.hold) {
    badges.push({
      label: "On hold",
      title: "On hold: nothing in this project can be deleted",
      tone: "neutral",
      icon: "pause",
    });
  }
  return <ExtensionBadgeIcons badges={badges} />;
};
